import { BookkeepingCycle } from 'jobs/bookkeeping/BookkeepingProgressionInfo'

const shortDateFormatter = new Intl.DateTimeFormat('en-US', {
  month: 'short',
  day: 'numeric',
})

const defaultDateFormatter = new Intl.DateTimeFormat('en-US', {
  year: 'numeric',
  month: 'short',
  day: 'numeric',
})

const dateFormatter = new Intl.DateTimeFormat('en-US', {
  year: 'numeric',
  month: 'numeric',
  day: 'numeric',
})

const longDateFormatter = new Intl.DateTimeFormat('en-US', {
  month: 'long',
  day: 'numeric',
  year: 'numeric',
})

const timeFormatter = new Intl.DateTimeFormat('en-US', {
  hour: 'numeric',
  minute: 'numeric',
})

/**
 * Formats the date to a string.
 * @param date
 * @returns `string`
 */
export function formatToLongDateWithTime(date: Date): string {
  return longDateFormatter.format(date) + ' ' + timeFormatter.format(date)
}

/**
 * Formats the date to a string.
 * @param date
 * @returns `string`
 */
export function formatShortDate(date: Date): string {
  return defaultDateFormatter.format(date)
}

export function formatCycleToShortDate(cycle: BookkeepingCycle) {
  return `${shortDateFormatter.format(cycle.startedAt)} - ${defaultDateFormatter.format(cycle.completedAt)}`
}

export function formatCycleCompletionDate(cycle: BookkeepingCycle) {
  return `${dateFormatter.format(cycle.startedAt)} - ${dateFormatter.format(cycle.completedAt)}`
}

export function formatCycleCompletedItems(cycle: BookkeepingCycle) {
  const completedItems = (cycle.workItemsCompletion || []).filter(
    (ci) => ci.completedCount > 0,
  )

  if (!completedItems.length) {
    return 'No items were completed in this cycle.'
  }

  return completedItems
    .map((ci) => `${ci.name} x ${ci.completedCount}`)
    .join(' | ')
}
